import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import HtmlParser from 'react-html-parser';

import moment from 'moment-timezone';
import 'react-tempusdominus-bootstrap';

import axios from 'axios';

import {
    responseGet, globalSettings, separatorsNumbersSet, styles, validateDecimals, sendMessageCloseCurrentWindowAsync, numberSet, dateTimeFormatGlobalSet,
    languageObjGet, isUndNullEmp, awaitDelay, isUndNull, isNumber
} from '../../helpers/settings'
import { purchaseModelGet } from '../../models/expenses/purchase';
import { purchasePaymentModelGet } from '../../models/expenses/purchasePayment';
import { GlobalFormats } from '../../classes/main/globalFormats';

const currentMethod = 'PurchasePaymentAddEditDetail';

const { collections, icons, labels, messages, } = globalSettings;
const { properties: dbProps, } = collections;

export default function PurchasePaymentAddEditDetail({
    $ = {},
    auth = {},
    purchase = purchaseModelGet({}),
    setPurchase = () => { },
    purchasePayment = purchasePaymentModelGet({}),
    setPurchasePayment = () => { },
    //#region old code
    // purchasePaymentDataGetAsync = async ({
    //     buildingId = '',
    //     limit = 0,
    //     valueReturn = false,
    //     auth = {},
    //     languageId = 'en',
    //     subMethod = '',
    // }) => { },
    //#endregion old code
    purchasePaymentDataGetAsync = async ({
        queryCodeSet = false,
        subMethod = '',
    }) => { },
    dtId = '',
    rowIndex = 0,
    paymentMethods = [],
    banks = [],
    bankOrigins = [],
    bankAccounts = [],
    collectionCashes = [],
    showModal = false,
    setShowModal = () => { },
    setShowView = () => { },
    processType = 0,
    setProcessType = () => { },
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let headerObj = {};
    let dataObj = {};
    const purchasePaymentDateId = 'purchasePaymentDate';
    const [bankAccountsByBank, setBankAccountsByBank] = useState([]);
    const [showBanks, setShowBanks] = useState(false);
    const [paymentMethodError, setPaymentMethodError] = useState('');
    const [bankOriginError, setBankOriginError] = useState('');
    const [bankAccountError, setBankAccountError] = useState('');
    const [bankDestinyError, setBankDestinyError] = useState('');
    const [collectionCashError, setCollectionCashError] = useState('');
    const [dateError, setDateError] = useState('');
    const [referenceError, setReferenceError] = useState('');
    const [amountError, setAmountError] = useState('');
    const [remarkError, setRemarkError] = useState('');
    const neutralValue = 0.00;
    const neutralValueStr = separatorsNumbersSet({
        number: neutralValue,
        withDecimals: true,
        consoleLogErrorShow: true,
        subMethod: currentMethod,
    })?.result;
    //#endregion variables

    //#region others
    const controls = {
        buttons: {
            save: {
                id: 'btnModalPurchasePaymentSave',
                className: 'btn btn-outline-warning',
            },
            back: {
                id: 'btnModalPurchasePaymentBack',
                className: 'btn btn-outline-success mx-1',
            },
            close: {
                id: 'btnModalPurchasePaymentClose',
                className: 'close btn-danger fas fa-window-close',
            },
        },
        checkBox: {
            // isNational: {
            //     attributes: {
            //     },
            //     id: 'chkIsNational',
            //     className: 'icheck-primary d-inline',
            // },
        },
        dataTables: {
            // expenseConcepts: {
            //     buttons: {
            //         // detailAdd: {
            //         //     className: 'btn btn-sm btn-outline-info mx-1 float-right',
            //         //     id: 'btnDtPurchaseDetailsIdDetail',
            //         // },
            //     },
            //     icons: {
            //         // detailAdd: {
            //         //     id: 'iconDtPurchaseDetailsIdDetailAdd',
            //         //     className: icons?.list,
            //         // },
            //     },
            //     inputs: {
            //         search: {
            //             id: `${dtConceptsId}_filter input`,
            //             className: '',
            //         },
            //     },
            //     selects: {
            //         entries: {
            //             id: `${dtConceptsId}_length select`,
            //             className: '',
            //         },
            //     },
            //     spinners: {
            //         // detailAdd: {
            //         //     id: 'spDtPurchaseDetailsIdDetailAdd',
            //         //     className: '',
            //         // },
            //     },
            // },
        },
        icons: {
            save: {
                id: 'icoModalPurchasePaymentSave',
                className: icons?.save,
            },
            close: {
                id: 'icoModalPurchasePaymentClose',
                className: icons?.paperClip,
            },
            back: {
                id: 'icoModalPurchasePaymentBack',
                className: icons?.arrowCircleLeft,
            },
        },
        inputs: {
            date: {
                id: 'inputModalPurchasePaymentDate',
                //className: 'form-control text-black bg-transparent datetimepicker-input',
                className: 'form-control datetimepicker-input',
            },
            reference: {
                id: 'inputModalPurchasePaymentReference',
                //className: 'form-control bg-transparent text-black',
                className: 'form-control',
            },
            amount: {
                id: 'inputModalPurchasePaymentAmount',
                //className: 'form-control text-black bg-transparent text-right',
                className: 'form-control text-right',
            },
            remark: {
                id: 'inputModalPurchasePaymentRemark',
                className: 'form-control',
            },
        },
        selects: {
            paymentMethods: {
                id: 'selModalPurchasePaymentPaymentMethods',
                //className: 'form-select bg-transparent text-black',
                className: 'form-select',
            },
            banksOrigin: {
                id: 'selModalPurchasePaymentBankOrigins',
                //className: 'form-select bg-transparent text-black',
                className: 'form-select',
            },
            bankAccounts: {
                id: 'selModalPurchasePaymentBankAccounts',
                //className: 'form-select bg-transparent text-black',
                className: 'form-select',
            },
            banks: {
                id: 'selModalPurchasePaymentBanks',
                //className: 'form-select bg-transparent text-black',
                className: 'form-select',
            },
            collectionCashes: {
                id: 'selModalPurchasePaymentCollectionCashes',
                //className: 'form-select bg-transparent text-black',
                className: 'form-select',
            },
        },
        spinners: {
            save: {
                id: 'spModalPurchasePaymentSave',
                className: '',
            },
            close: {
                id: 'spModalPurchasePaymentClose',
                className: '',
            },
            back: {
                id: 'spModalPurchasePaymentBack',
                className: '',
            },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region purchase payments (methods)
    const purchasePaymentAddPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'purchasePaymentAddPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            await errosDefaultSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion initialize

            //#region payment data set
            response = await purchasePaymentDataSetAsync({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion payment data set

            //#region validate form
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion validate form

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region create purchasePayment
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                purchasePayment: purchasePayment,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchasePayments}/`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion create purchasePayment

            //#region purchasePayment data get
            //#region old code
            // response = await purchasePaymentDataGetAsync({
            //     buildingId: purchasePayment?.buildingId,
            //     limit: 0,
            //     valueReturn: true,
            //     auth: auth,
            //     languageId: languageObj?.id,
            //     subMethod: currentMethod,
            // });
            //#endregion old code

            response = await purchasePaymentDataGetAsync({
                queryCodeSet: false,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion purchasePayment data get

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const purchasePaymentEditPostAsync = async ({ e = {}, subMethod = '', }) => {
        const currentMethod = 'purchasePaymentEditPostAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region initialize
            await errosDefaultSetAsync({ subMethod: currentMethod, });
            //#endregion initialize

            //#region payment data set
            response = await purchasePaymentDataSetAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion payment data set

            //#region validate form
            response = await formDataValidateAsync({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion validate form

            controlsStatusSet({ processType: 1, subMethod: currentMethod, });

            //#region purchase payment update
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                },
            };

            dataObj = {
                purchasePayment: purchasePayment,
                languageCode: languageObj?.code,
                languageId: languageObj?.id,
                url: `${globalSettings?.app?.backend?.url}${globalSettings?.app?.backend?.urlApiV1}${globalSettings?.app?.backend?.urlPurchasePayments}/${purchasePayment.id}`,
            };

            result = await axios?.post(
                dataObj?.url,
                dataObj,
                headerObj,
            );

            response = result?.data;

            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion purchase payment update

            //#region payment data get
            response = await purchasePaymentDataGetAsync({
                buildingId: purchasePayment?.buildingId,
                limit: 0,
                valueReturn: true,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion payment data get

            await defaultValueSetAsync({ isModalClose: true, subMethod: currentMethod, });

            await sendMessageCloseCurrentWindowAsync({
                msgType: 0,
                msgText: messages?.processesCompletedSuccessfully?.[languageObj?.id],
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        } catch (ex) {
            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const purchasePaymentDataSetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'purchasePaymentDataSetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //const dateTimeObj?.date = $(`#${purchasePaymentDateId}`)?.datetimepicker('date')?._d;
            //#endregion old code
            const dateTimeObj = {
                date: $(`#${purchasePaymentDateId}`)?.datetimepicker('date')?._d,
            };
            //#endregion variables

            //#region methods
            purchasePayment.date = !isUndNullEmp({ data: dateTimeObj?.date, subMethod: currentMethod, })?.result ? dateTimeObj?.date : purchasePayment?.date;
            purchasePayment.amount = numberSet({
                number: !isUndNullEmp({ data: purchasePayment?.amount, subMethod: currentMethod, })?.result ? purchasePayment?.amount : neutralValue,
                type: 'd',
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion purchase payments (methods)

    //#region banks (methods)
    const bankAccountsGetByBankIdAsync = async ({ e = {}, subMethod = '' }) => {
        const currentMethod = 'bankAccountsGetByBankIdAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region methods
            setPurchasePayment({
                ...purchasePayment,
                [dbProps?.bankOriginId]: e?.target?.value,
                [dbProps?.bankAccountId]: '',
            });

            if (!isUndNullEmp({ data: e?.target?.value, subMethod: currentMethod, })?.result) {
                setBankAccountsByBank(bankAccounts?.filter(({ bankId }) => bankId === e?.target?.value));
            } else {
                setBankAccountsByBank([]);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }
    //#endregion banks (methods)

    //#region methods (others)
    const dataGetAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region methods
            await dateInControlSetAsync({
                date: new Date(),
                purchasePaymentDate: purchasePayment?.date,
                subMethod: currentMethod,
            });

            setShowBanks(!isUndNullEmp({ data: purchasePayment?.bankOriginId, subMethod: currentMethod, })?.result);

            //#region old code
            // if (!isUndNullEmp({ data: purchasePayment?.bankAccountId, subMethod: currentMethod, })?.result &&
            //     !isUndNullEmp({ data: purchasePayment?.bankAccountId, subMethod: currentMethod, })?.result && processType !== 0) {
            //     setBankAccountsByBank(bankAccounts?.filter(({ id }) => id === purchasePayment?.bankAccountId) || []);
            // }
            //#endregion old code

            if (!isUndNullEmp({ data: purchasePayment?.bankOriginId, subMethod: currentMethod, })?.result &&
                !isUndNullEmp({ data: purchasePayment?.bankAccountId, subMethod: currentMethod, })?.result && processType !== 0) {
                setBankAccountsByBank(bankAccounts?.filter(({ bankId }) => bankId === purchasePayment?.bankOriginId) || []);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const defaultValueSetAsync = async ({ isModalClose = false, subMethod = '', }) => {
        const currentMethod = 'defaultValueSetAsync';
        let response = responseGet();
        try {
            if (isModalClose) {
                //setProcessType(0);
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                await errosDefaultSetAsync({ subMethod: currentMethod, });
                controlsStatusSet({ processType: 2, subMethod: currentMethod, });
                await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            }
            setShowModal(!isModalClose);
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const formValueSetAsync = async ({ property = '', value = '', isShowBanks = false, subMethod = '', }) => {
        const currentMethod = 'formValueSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let processed = false;
            //#endregion variables

            //#region methods
            if (isShowBanks) {
                const paymentMethodLocal = paymentMethods?.find(({ id }) => id === value);
                if (!isUndNullEmp({ data: paymentMethodLocal, subMethod: currentMethod, })?.result &&
                    !isUndNullEmp({ data: paymentMethodLocal?.showBanks, subMethod: currentMethod, })?.result) {
                    if (!paymentMethodLocal?.showBanks) {
                        processed = true;
                    }
                    setShowBanks(paymentMethodLocal?.showBanks);
                } else {
                    setShowBanks(false);
                    processed = true;
                }
            }

            if (!processed) {
                if (property !== dbProps?.collectionCashId) {
                    setPurchasePayment({ ...purchasePayment, [property]: value, collectionCashId: '', });
                } else {
                    setPurchasePayment({ ...purchasePayment, [property]: value, });
                }
            } else {
                if (isUndNullEmp({ data: value, subMethod: currentMethod, })?.result) {
                    setPurchasePayment({ ...purchasePayment, [property]: value, bankOriginId: '', bankId: '', bankAccountId: '', collectionCashId: '', });
                } else {
                    setPurchasePayment({ ...purchasePayment, [property]: value, bankOriginId: '', bankId: '', bankAccountId: '', });
                }
                setBankAccountsByBank([]);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dateInControlSetAsync = async ({ date = new Date(), purchasePaymentDate = undefined, subMethod = '', }) => {
        let response = responseGet();
        try {
            //#region variables
            //#region old code
            //let dateTimeObj?.date = '';
            //const dateTimeObj?.format = globalSettings?.react?.tempusDominus?.format?.date?.dmy;
            //const dateTimeObj?.formatTwo = globalSettings?.react?.tempusDominus?.format?.date?.DDMMYYYY;
            //#endregion old code
            const dateTimeObj = {
                date: '',
                time: 0,
                format: languageObj?.format?.date?.f1,
                formatTwo: languageObj?.format?.date?.f11,
            };
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: purchasePaymentDate, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: purchasePaymentDate,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else if (!isUndNullEmp({ data: date, subMethod: currentMethod, })?.result) {
                dateTimeObj.date = dateTimeFormatGlobalSet({
                    date: date,
                    type: dateTimeObj?.format,
                    format: dateTimeObj?.time,
                    addTime: false,
                    secondsShow: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: globalSettings?.react?.tempusDominus?.icons,
                buttons: globalSettings?.react?.tempusDominus?.buttons,
                tooltips: globalSettings?.react?.tempusDominus?.tooltips,
                locale: languageObj?.id,
            });

            $(`#${purchasePaymentDateId}`)?.datetimepicker({
                'date': moment(dateTimeObj?.date, dateTimeObj?.formatTwo),
                default: false,
                format: dateTimeObj?.formatTwo,
            });
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const formDataValidateAsync = async ({ subMethod = '', }) => {
        const currentMethod = 'formDataValidateAsync';
        let response = responseGet();
        try {
            //#region variables
            const dateTimeObj = {
                date: $(`#${controls?.inputs?.date?.id}`)?.val(),
            };
            //#endregion variables

            //#region methods
            if (isUndNullEmp({ data: purchasePayment?.paymentMethodId, subMethod: currentMethod, })?.result) {
                setPaymentMethodError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dateTimeObj?.date, subMethod: currentMethod, })?.result ||
                isUndNullEmp({ data: purchasePayment?.date, subMethod: currentMethod, })?.result) {
                setDateError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: purchasePayment?.reference, subMethod: currentMethod, })?.result) {
                setReferenceError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
            }

            if (showBanks) {
                if (isUndNullEmp({ data: purchasePayment?.bankOriginId, subMethod: currentMethod, })?.result) {
                    setBankOriginError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                    response.isWarning = true;
                }

                if (isUndNullEmp({ data: purchasePayment?.bankAccountId, subMethod: currentMethod, })?.result) {
                    setBankAccountError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                    response.isWarning = true;
                }

                if (isUndNullEmp({ data: purchasePayment?.bankId, subMethod: currentMethod, })?.result) {
                    setBankDestinyError(`${messages?.thisFieldRequired?.[languageObj?.id]}`);
                    response.isWarning = true;
                }
            } else {
                if (isUndNullEmp({ data: purchasePayment?.collectionCashId, subMethod: currentMethod, })?.result) {
                    setCollectionCashError(messages?.thisFieldRequired?.[languageObj?.id]);
                    response.isWarning = true;
                }
            }

            if (isUndNull({ data: purchasePayment?.amount, subMethod: currentMethod, })?.result) {
                setAmountError(messages?.thisFieldRequired?.[languageObj?.id]);
                response.isWarning = true;
                //#region old code
                //} else if (purchasePayment?.amount <= neutralValue || isNaN(purchasePayment?.amount)) {
                //#endregion old code
            } else if (purchasePayment?.amount <= neutralValue ||
                !isNumber({ number: purchasePayment?.amount, languageId: languageObj?.id, subMethod: currentMethod, })?.result) {
                setAmountError(`${labels?.amount?.[languageObj?.id]}. ${messages?.mustBeGreaterThan?.[languageObj?.id]} <b>${neutralValueStr}</b>`);
                response.isWarning = true;
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const errosDefaultSetAsync = async ({ subMethod = '', }) => {
        let response = responseGet();
        try {
            setDateError('');
            setAmountError('');
            setReferenceError('');
            setReferenceError('');
            setBankOriginError('');
            setBankDestinyError('');
            setBankAccountError('');
            setPaymentMethodError('');
            setCollectionCashError('');
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    for (let ctrStr in controls) {
                        const objStr = ['buttons', 'spinners', 'icons'];
                        if (objStr?.includes(ctrStr)) {
                            for (let propStr in controls?.[ctrStr]) {
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.removeClass();
                                $(`#${controls?.[ctrStr]?.[propStr]?.id}`)?.addClass(controls?.[ctrStr]?.[propStr]?.className);
                            }
                        }
                    }
                    break;
                case 1:
                    //$(`#${controls?.buttons?.create?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.icons?.save?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                case 2:
                    $(`#${controls?.icons?.back?.id}`)?.removeClass();
                    $(`#${controls?.spinners?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region controls
            $(`#${controls?.selects?.paymentMethods?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.selects?.banksOrigin?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.selects?.bankAccounts?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.selects?.banks?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.selects?.collectionCashes?.id}`).attr('disabled', (processType !== 0));
            $(`#${controls?.inputs?.date?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.reference?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.amount?.id}`).attr('readOnly', (processType !== 0));
            $(`#${controls?.inputs?.remark?.id}`).attr('readOnly', (processType !== 0));
            //#endregion controls

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.app?.backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            // $(`#${controls?.dataTables?.expenseConcepts?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            // $(`#${controls?.dataTables?.expenseConcepts?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.buttons?.save?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.back?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
                $(`#${controls?.buttons?.close?.id}`)?.addClass(`${globalSettings?.react?.html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({ subMethod: 'form - onLoad', });
    }, []) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <Modal backdrop='static' show={showModal} onHide={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - onHide', })}>
            <Modal.Header>
                <Modal.Title>
                    <img alt={labels?.purchase?.[languageObj?.id]}
                        src={globalSettings?.images?.paymentsLogo}
                        style={styles?.cardHeaderLogo}>
                    </img> - {processType === 0 ? labels?.registerPayment?.[languageObj?.id] : (processType === 1 ? labels?.edit?.[languageObj?.id] : labels?.paymentDetails?.[languageObj?.id])}
                </Modal.Title>
                <button id={controls?.buttons?.close?.id}
                    className={controls?.buttons?.close?.className}
                    type='button'
                    data-dismiss='modal'
                    aria-label='Close'
                    onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnClose', })}>
                </button>
            </Modal.Header>
            <form onSubmit={(e) => processType === 0 ?
                purchasePaymentAddPostAsync({ e: e, subMethod: 'form - onSubmit' }) :
                (processType === 1 ? purchasePaymentEditPostAsync({ e: e, subMethod: 'form - onSubmit', }) : e?.preventDefault())}>
                <Modal.Body>
                    {/* <form onSubmit={(e) => processType === 0 ? purchasePaymentAddPostAsync(e) : (processType === 1 ? purchasePaymentEditPostAsync(e) : e?.preventDefault())}> */}
                    {/* <div className='card'> */}
                    {/* <div className='card-body'> */}

                    {processType !== 2 ?
                        //#region add / edit
                        <div>
                            {/* {!isUndNullEmp({ data: paymentMethods, subMethod: currentMethod, })?.result &&
                                !isUndNullEmp({ data: purchasePayment, subMethod: currentMethod, })?.result ? */}
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <select id={controls?.selects?.paymentMethods?.id}
                                                className={controls?.selects?.paymentMethods?.className}
                                                //autoFocus
                                                defaultValue={purchasePayment?.paymentMethodId || ''}
                                                onChange={(e) => formValueSetAsync({
                                                    property: dbProps?.paymentMethodId,
                                                    value: e?.target?.value,
                                                    isShowBanks: true,
                                                    subMethod: 'sel - paymentThethod',
                                                })}
                                                onFocus={() => setPaymentMethodError('')}
                                                placeholder={labels?.paymentMethods?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.paymentMethods?.[languageObj?.id]} >
                                                <option value=''>{labels?.selectPaymentMethod?.[languageObj?.id]}</option>
                                                {paymentMethods?.map((detail) => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                            </select>
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.cashRegister} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(paymentMethodError)}</div>
                                    </div>
                                </div>
                            </div>
                            {/* : */}
                            {/* <></> */}
                            {/* } */}

                            {/* {!isUndefined(banks) && !isUndefined(purchasePayment) && showBanks ? */}
                            {showBanks ?
                                <div>
                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <select id={controls?.selects?.banksOrigin?.id}
                                                        className={controls?.selects?.banksOrigin?.className}
                                                        defaultValue={purchasePayment?.bankOriginId || ''}
                                                        onChange={(e) => bankAccountsGetByBankIdAsync({ e: e, subMethod: 'selBankAccounts', })}
                                                        onFocus={() => setBankOriginError('')}
                                                        placeholder={labels?.banks?.[languageObj?.id]}
                                                        tooltip='tooltip'
                                                        title={`${labels?.bank?.[languageObj?.id]} (${labels?.origin?.[languageObj?.id]})`} >
                                                        <option value=''>{`${labels?.selectBank?.[languageObj?.id]} (${labels?.origin?.[languageObj?.id]?.toLowerCase()})`}</option>
                                                        {bankOrigins?.map((detail) => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                                    </select>
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text'>
                                                            <span className={icons?.university} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(bankOriginError)}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <select id={controls?.selects?.bankAccounts?.id}
                                                        className={controls?.selects?.bankAccounts?.className}
                                                        //defaultValue={purchasePayment?.bankAccountId || ''}
                                                        value={purchasePayment?.bankAccountId || ''}
                                                        onChange={(e) => formValueSetAsync({
                                                            property: dbProps?.bankAccountId,
                                                            value: e?.target?.value,
                                                            isShowBanks: false,
                                                            subMethod: 'sel - bankAccount',
                                                        })}
                                                        onFocus={() => setBankAccountError('')}
                                                        placeholder={labels?.bankAccount?.[languageObj?.id]}
                                                        tooltip='tooltip'
                                                        title={`${labels?.bankAccount?.[languageObj?.id]} (${labels?.origin?.[languageObj?.id]})`} >
                                                        <option key='nothing' value=''>{`${messages?.selectBankAccount?.[languageObj?.id]}`}</option>
                                                        {bankAccountsByBank?.map((detail) => (<option key={detail?.id} value={detail?.id}>{detail?.number}</option>))}
                                                    </select>
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text'>
                                                            <span className={icons?.piggyBank} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(bankAccountError)}</div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row'>
                                        <div className='col-md-12'>
                                            <div className='form-group'>
                                                <div className='input-group mb-3'>
                                                    <select id={controls?.selects?.banks?.id}
                                                        className={controls?.selects?.banks?.className}
                                                        defaultValue={purchasePayment?.bankId || ''}
                                                        onChange={(e) => formValueSetAsync({
                                                            property: dbProps?.bankId,
                                                            value: e?.target?.value,
                                                            isShowBanks: false,
                                                            subMethod: 'sel - bank',
                                                        })}
                                                        onFocus={() => setBankDestinyError('')}
                                                        placeholder={labels?.banks?.[languageObj?.id]}
                                                        tooltip='tooltip'
                                                        title={`${labels?.bank?.[languageObj?.id]} (${labels?.destiny?.[languageObj?.id]})`} >
                                                        <option key='nothing' value=''>{`${labels?.selectBank?.[languageObj?.id]} (${labels?.destiny?.[languageObj?.id]?.toLowerCase()})`}</option>
                                                        {banks?.map((detail) => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                                    </select>
                                                    <div className='input-group-append'>
                                                        <div className='input-group-text'>
                                                            <span className={icons?.university} />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(bankDestinyError)}</div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                :
                                <></>
                            }

                            {!isUndNullEmp({ data: purchasePayment?.paymentMethodId, subMethod: currentMethod, })?.result &&
                                !isUndNullEmp({ data: purchasePayment?.paymentMethodId, subMethod: currentMethod, })?.result &&
                                !showBanks ?
                                <div className='row'>
                                    <div className='col-md-12'>
                                        <div className='form-group'>
                                            <div className='input-group mb-3'>
                                                <select id={controls?.selects?.collectionCashes?.id}
                                                    className={controls?.selects?.collectionCashes?.className}
                                                    defaultValue={purchasePayment?.collectionCashId || ''}
                                                    onChange={(e) => formValueSetAsync({
                                                        property: dbProps?.collectionCashId,
                                                        value: e?.target?.value,
                                                        isShowBanks: false,
                                                        subMethod: 'sel - collectionCaches',
                                                    })}
                                                    onFocus={() => setCollectionCashError('')}
                                                    placeholder={messages?.selectCashRegister?.[languageObj?.id]}
                                                    tooltip='tooltip'
                                                    title={labels?.cashRegister?.[languageObj?.id]}>
                                                    <option value=''>{messages?.selectCashRegister?.[languageObj?.id]}</option>
                                                    {collectionCashes?.map((detail) => (<option key={detail?.id} value={detail?.id}>{detail?.description}</option>))}
                                                </select>
                                                <div className='input-group-append'>
                                                    <div className='input-group-text'>
                                                        <span className={icons?.university} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(collectionCashError)}</div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <></>
                            }

                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        {/* <DatePicker /> */}
                                        <div className='input-group mb-3'>
                                            {/* {!isUndefined(purchasePayment) && !isUndefined(purchasePayment.date) ? */}
                                            <div id={purchasePaymentDateId}
                                                className='input-group date'
                                                data-target-input='nearest'>
                                                <input id={controls?.inputs?.date?.id}
                                                    className={controls?.inputs?.date?.className}
                                                    data-target={`#${purchasePaymentDateId}`}
                                                    data-toggle='datetimepicker'
                                                    onFocus={() => setDateError('')}
                                                    placeholder={labels?.date?.[languageObj?.id]}
                                                    //tabIndex={-1}
                                                    tooltip='tooltip'
                                                    title={labels?.date?.[languageObj?.id]}
                                                    type='text' />
                                                <div className='input-group-append'
                                                    data-target={`#${purchasePaymentDateId}`}
                                                    data-toggle='datetimepicker'>
                                                    <div className='input-group-text'><i className={icons?.calendarAlt}></i></div>
                                                </div>
                                            </div>
                                            {/* : */}
                                            {/* <></> */}
                                            {/* } */}
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(dateError)}</div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.reference?.id}
                                                className={controls?.inputs?.reference?.className}
                                                onChange={(e) => setPurchasePayment({
                                                    ...purchasePayment,
                                                    [dbProps?.reference]: e?.target?.value,
                                                })}
                                                onFocus={() => setReferenceError('')}
                                                placeholder={labels?.reference?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.reference?.[languageObj?.id]}
                                                value={purchasePayment?.reference || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.spellCheck} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(referenceError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <input id={controls?.inputs?.amount?.id}
                                                className={controls?.inputs?.amount?.className}
                                                //onChange={(e) => setPurchasePayment({ ...purchasePayment, amount: validateDecimals(e), })}
                                                onChange={(e) => setPurchasePayment({
                                                    ...purchasePayment,
                                                    [dbProps?.amount]: validateDecimals({ e: e, languageId: languageObj?.id, subMethod: 'input - amount', }),
                                                })}
                                                onFocus={() => setAmountError('')}
                                                placeholder={labels?.amount?.[languageObj?.id]}
                                                tooltip='tooltip'
                                                title={labels?.amount?.[languageObj?.id]}
                                                // value={!isUndefined(purchasePayment.amount) ?
                                                //     (purchasePayment.amount === neutralValue ?
                                                //         neutralValue : isNaN(purchasePayment.amount) ?
                                                //             neutralValue : (processType === 2 ?
                                                //                 separatorsNumbersSet(purchasePayment.amount) : purchasePayment.amount)) : neutralValue} />
                                                value={purchasePayment?.amount || '0.00'} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(amountError)}</div>
                                    </div>
                                </div>
                            </div>

                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='form-group'>
                                        <div className='input-group mb-3'>
                                            <textarea id={controls?.inputs?.remark?.id}
                                                className={controls?.inputs?.remark?.className}
                                                onChange={(e) => setPurchasePayment({
                                                    ...purchasePayment,
                                                    [dbProps?.remark]: e?.target?.value,
                                                })}
                                                onFocus={() => setRemarkError('')}
                                                placeholder={labels?.remark?.[languageObj?.id]}
                                                rows={2}
                                                tooltip='tooltip'
                                                title={labels?.remark?.[languageObj?.id]}
                                                value={purchasePayment.remark || ''} />
                                            <div className='input-group-append'>
                                                <div className='input-group-text'>
                                                    <span className={icons?.moneyBillWave} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className='form-text' style={styles?.labelMsgAlert}>{HtmlParser(remarkError)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        //#endregion add / edit
                        :
                        //#region details
                        <div>
                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.paymentMethod?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{paymentMethods?.find(({ id }) => id === purchasePayment?.paymentMethodId)?.description || ''}</b>
                                </div>
                            </div>

                            {showBanks ?
                                <div>
                                    <div className='row text-muted'>
                                        <div className='col-md-4'>
                                            {labels?.bank?.[languageObj?.id]} ({labels?.origin?.[languageObj?.id]}):
                                        </div>
                                        <div className='col-md-8'>
                                            <b>{banks?.find(({ id }) => id === purchasePayment?.bankOriginId)?.description || ''}</b>
                                        </div>
                                    </div>

                                    <div className='row text-muted'>
                                        <div className='col-md-4'>
                                            {labels?.account?.[languageObj?.id]} ({labels?.origin?.[languageObj?.id]}):
                                        </div>
                                        <div className='col-md-8'>
                                            <b>{bankAccounts?.find(({ id }) => id === purchasePayment?.bankAccountId)?.number || ''}</b>
                                        </div>
                                    </div>

                                    <div className='row text-muted'>
                                        <div className='col-md-4'>
                                            {labels?.bank?.[languageObj?.id]} ({labels?.destiny?.[languageObj?.id]}):
                                        </div>
                                        <div className='col-md-8'>
                                            <b>{banks?.find(({ id }) => id === purchasePayment?.bankId)?.description || ''}</b>
                                        </div>
                                    </div>

                                </div>
                                :
                                <></>
                            }

                            {!isUndNullEmp({ data: purchasePayment?.collectionCashId, subMethod: currentMethod, })?.result ?
                                <div className='row text-muted'>
                                    <div className='col-md-4'>
                                        {labels?.collectionCash?.[languageObj?.id]}:
                                    </div>
                                    <div className='col-md-8'>
                                        <b>{collectionCashes?.find(({ id, }) => id === purchasePayment?.collectionCashId)?.description || ''}</b>
                                    </div>
                                </div>
                                :
                                <></>
                            }

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.date?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        // !isUndefined(purchasePayment.date) ?
                                        //     !isUndefined(purchasePayment.date.seconds) ?
                                        //         dateTimeFormatSet(purchasePayment.date.seconds, 'd/m/y', 0) : dateTimeFormatSetTwo(purchasePayment.date, 'd/m/y', 0) : ''
                                        dateTimeFormatGlobalSet({
                                            date: purchasePayment?.date || new Date(),
                                            type: languageObj?.format?.date?.f1,
                                            format: 0,
                                            addTime: false,
                                            secondsShow: false,
                                            languageId: languageObj?.id,
                                            subMethod: 'lbl - date',
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.reference?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{purchasePayment.reference || ''}</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.amount?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{
                                        separatorsNumbersSet({
                                            number: purchasePayment?.amount || neutralValue,
                                            withDecimals: true,
                                            consoleLogErrorShow: true,
                                            subMethod: currentMethod,
                                        })?.result
                                    }</b>
                                </div>
                            </div>

                            <div className='row text-muted'>
                                <div className='col-md-4'>
                                    {labels?.remark?.[languageObj?.id]}:
                                </div>
                                <div className='col-md-8'>
                                    <b>{HtmlParser(`${purchasePayment?.remark?.replaceAll('\n', '</br>')}`) || ''}</b>
                                </div>
                            </div>

                            <hr />
                        </div>
                        //#endregion details
                    }

                    {/* </div> */}

                    {/* <div className='card-footer'>
                            <div className='form-group text-right'>
                                <button className='btn btn-outline-warning'
                                    hidden={processType === 2}
                                    tooltip='tooltip'
                                    title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                    type='submit'>
                                    <i className={icons?.save}></i>
                                </button>
                                <button className='btn btn-outline-success mx-1'
                                    tooltip='tooltip'
                                    title={labels?.close?.[languageObj?.id]}
                                    type='reset'
                                    onClick={() => defaultValueSetAsync(true)}>
                                    <i className={icons?.arrowCircleLeft}></i>
                                </button>
                            </div>
                        </div> */}
                    {/* </div> */}
                    {/* </form> */}
                </Modal.Body>
                <Modal.Footer>
                    <div className='form-group text-right'>
                        <button id={controls?.buttons?.save?.id}
                            className={controls?.buttons?.save?.className}
                            hidden={processType === 2}
                            tooltip='tooltip'
                            title={processType === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                            type='submit'>
                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.className} /> <span id={controls?.spinners?.save?.id} className='' aria-hidden='true'></span>
                        </button>
                        <button id={controls?.buttons?.back?.id}
                            className={controls?.buttons?.back?.className}
                            //className='btn btn-outline-success mx-1'
                            tooltip='tooltip'
                            title={labels?.close?.[languageObj?.id]}
                            type='reset'
                            onClick={() => defaultValueSetAsync({ isModalClose: true, subMethod: 'form - btnBack', })}>
                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.className} /> <span id={controls?.spinners?.back?.id} className='' aria-hidden='true'></span>
                        </button>
                    </div>
                </Modal.Footer>
            </form>
        </Modal>
    )
}